module.exports = __webpack_public_path__ + "img/2.e6a7e7f4.jpg";